"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themesConfig = exports.rootFontSizeMultiplier = exports.defaultHeading = exports["default"] = void 0;
var _colours = require("../../fuse-colours/src/colours");
var _typography = require("../../fuse-typography/src/typography");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
// Multiplier set to 1.6 due to root font-size of page being 10px and rounding to 1 decimal place
var rootFontSizeMultiplier = exports.rootFontSizeMultiplier = 1.6;
var littlewoods = _colours.brand.littlewoods,
  very = _colours.brand.very;
var sharedViewportHeadingSize = {
  xxs: {
    h1: '5',
    h2: '4',
    h3: '3',
    h4: '2',
    h5: '1',
    h6: 'M1'
  },
  m: {
    h1: '6',
    h2: '5',
    h3: '4',
    h4: '3',
    h5: '2',
    h6: '1'
  },
  l: {
    h1: '7',
    h2: '6',
    h3: '5',
    h4: '4',
    h5: '3',
    h6: '2'
  }
};

/**
 * Default heading sizes for global theme component from h1 - h6 tags
 * Current config means heading sizes for both brands are the same and shared though this can be changed in the future
 */
var defaultHeading = exports.defaultHeading = {
  littlewoods: _objectSpread({}, sharedViewportHeadingSize),
  very: _objectSpread({}, sharedViewportHeadingSize)
};
var themesConfig = exports.themesConfig = {
  "default": {
    name: 'Default',
    color: {
      100: very.pink100,
      200: very.pink200,
      300: very.pink300,
      400: very.pink400,
      500: very.pink500,
      600: very.pink600,
      700: very.pink700,
      800: very.pink800,
      900: very.pink900,
      dark: very.pinkDark,
      mid: very.pinkMid,
      light: very.pinkLight,
      onBlack: very.onBlack,
      enhancedText: very.enhancedText
    },
    dark: very.pinkDark,
    mid: very.pinkMid,
    light: very.pinkLight,
    baseFontColour: _colours.global.grey900,
    fontFamily: _typography.fontFamily.very,
    defaultHeading: defaultHeading.very
  },
  littlewoods: {
    name: 'Fuse Littlewoods',
    color: {
      100: littlewoods.purple100,
      200: littlewoods.purple200,
      300: littlewoods.purple300,
      400: littlewoods.purple400,
      500: littlewoods.purple500,
      600: littlewoods.purple600,
      700: littlewoods.purple700,
      800: littlewoods.purple800,
      900: littlewoods.purple900,
      dark: littlewoods.purpleDark,
      mid: littlewoods.purpleMid,
      light: littlewoods.purpleLight,
      onBlack: littlewoods.onBlack,
      enhancedText: littlewoods.enhancedText
    },
    dark: littlewoods.purpleDark,
    mid: littlewoods.purpleMid,
    light: littlewoods.purpleLight,
    baseFontColour: _colours.global.grey900,
    fontFamily: _typography.fontFamily.littlewoods,
    defaultHeading: defaultHeading.littlewoods
  },
  very: {
    name: 'Fuse Very',
    color: {
      100: very.pink100,
      200: very.pink200,
      300: very.pink300,
      400: very.pink400,
      500: very.pink500,
      600: very.pink600,
      700: very.pink700,
      800: very.pink800,
      900: very.pink900,
      dark: very.pinkDark,
      mid: very.pinkMid,
      light: very.pinkLight,
      onBlack: very.onBlack,
      enhancedText: very.enhancedText
    },
    dark: very.pinkDark,
    mid: very.pinkMid,
    light: very.pinkLight,
    baseFontColour: _colours.global.grey900,
    fontFamily: _typography.fontFamily.very,
    defaultHeading: defaultHeading.very
  }
};
var _default = exports["default"] = themesConfig;